"use client";
import { ShareNodes } from "@areahub/icons";
import { Box, BoxProps } from "@chakra-ui/react";

export interface ShareButtonProps extends BoxProps {}

export const ShareButton = (props: ShareButtonProps) => {
  return (
    <Box
      borderRadius="full"
      p="7px"
      boxSize="30px"
      background="white"
      cursor="pointer"
      _hover={{
        transform: "scale(1.05)",
      }}
      {...props}
    >
      <Box
        as={ShareNodes}
        display="block"
        mx="auto"
        boxSize="15px"
        color="blue.300"
      />
    </Box>
  );
};
